import createMuiTheme from '@material-ui/core/styles/createMuiTheme'

const primaryColor = 'rgb(89,32,99)'
const secondaryColor = 'rgb(0,92,89)'
const black = '#222222'
const darkGrey = '#868686'
export const createACardTheme = createMuiTheme({
    palette: {
        primary: {
            main: primaryColor,
        },
        secondary: {
            main: secondaryColor,
        },
    },
    typography: {
        h1: {
            margin: '1rem 0',
            fontSize: '2rem',
            fontWeight: 'bold',
            '@media (min-width:600px)': {
                fontSize: '3rem',
            },
        },
        h2: {
            margin: '1.5rem 0 1rem 0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
        },
        body1: {
            fontSize: '1.1rem',
        },
    },
    overrides: {
        MuiInputLabel: {
            outlined: {
                color: 'gray',
                '&$shrink': {
                    color: black,
                },
            },
        },
        MuiOutlinedInput: {
            notchedOutline: {
                borderWidth: '2px',
                borderColor: darkGrey,
            },
        },
        MuiInputBase: {
            input: {
                '&::-webkit-input-placeholder': {
                    color: darkGrey,
                    opacity: 1,
                },
                '&::-moz-input-placeholder': {
                    color: darkGrey,
                    opacity: 1,
                },
                '&::-ms-input-placeholder': {
                    color: darkGrey,
                    opacity: 1,
                },
            },
        },
        MuiButton: {
            outlinedPrimary: {
                borderWidth: '2px',
                '&:hover': {
                    borderWidth: '2px',
                },
            },
        },
    },
})

export const rootStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '80vh',
        paddingBottom: '2rem',
        backgroundColor: '#F4F4F4',
        '& img': {
            display: 'block',
            maxWidth: '100%',
        },
    },
}
